interface ITopBannerMessage {
  topBannerMessageId: string;
  title: string;
  text: string;
  backdrop: boolean;
  closeCallback?: () => void;
}

export default class TopBannerMessage implements ITopBannerMessage {
  topBannerMessageId!: string;
  title!: string;
  text!: string;
  backdrop!: boolean;
  closeCallback?: () => void;
  constructor(data: ITopBannerMessage) {
    for (var property in data) {
      if (data.hasOwnProperty(property))
        (<any>this)[property] = (<any>data)[property];
    }
  }
}
